import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerTempAvailabilityDetailsRequest extends BaseUpdateRequest {
    availability: string[] = [];
}